import { render } from "./accountbalance.vue?vue&type=template&id=0554f691"
import script from "./accountbalance.vue?vue&type=script&lang=js"
export * from "./accountbalance.vue?vue&type=script&lang=js"

import "./accountbalance.vue?vue&type=style&index=0&id=0554f691&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__